/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Opaque from "App/render/webgl/nodes/bins/opaque_bin";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import Pass from "App/render/webgl/passes/pass";
import WebGLContext from "App/web_gl_context";
import {mat4} from "gl-matrix";
import RenderBinNode from "App/render/webgl/nodes/render_bin_node";
import Factory from "App/render/webgl/nodes/bins/factory";
import ScreenWithShadowVolumes from "App/render/webgl/passes/screen_with_shadow_volumes";
import {BillboardBinTypeName} from "App/render/webgl/nodes/bins/type_names";
import IScene from "js_interface/src/scene_interface";

export default
class Billboard extends Opaque {

    public static TypeName: string = BillboardBinTypeName;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): Billboard {
        return new Billboard(aSceneAPI, aRenderGraph);
    }

    public setUniforms(aRenderPass: Pass) {
        let view = aRenderPass.view;
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

        // we need to call super.super
        RenderBinNode.prototype.setUniforms.call(this, aRenderPass);

        let inverse = mat4.create();
        mat4.invert(inverse, view.getCamera().getViewMatrix());
        gl.uniformMatrix4fv(shader.uniformLocations.u_view_matrix_matrix, false, view.getCamera().getViewMatrix());
        gl.uniformMatrix4fv(shader.uniformLocations.u_projection_matrix, false, view.getCamera().getProjectionMatrixRef());
    }

    public render(aRenderPass: Pass): boolean {
        if (aRenderPass.getClassTypeName() === ScreenWithShadowVolumes.TypeName) {
            // TB: hack: do not blend during shadow volumes rendering
            super.render(aRenderPass);
        } else {
            let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

            // enable alpha blending
            gl.enable(gl.BLEND);
            gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE);

            super.render(aRenderPass);

            gl.disable(gl.BLEND);
        }

        return true;
    }
}

Factory.register(Billboard);
